<template>
  <div class="scene-data-container">
    <div
      v-show="!sceneLoadFinish"
      class="spin-box">
      <Spin
        :pointNum="8"
        :translateX="25"
        background="var(--base-primary-bgColor)" />
    </div>
    <div
      v-show="sceneLoadFinish"
      class="scene-data-box">
      <div
        v-if="sceneData.length"
        class="common-tree-box">
        <el-tree
          class="dialog-tree-primary"
          ref="sceneDataTree"
          :data="sceneData"
          :props="defaultProps"
          node-key="nodeId"
          highlight-current
          :show-checkbox="isShowCheckbox"
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
          @check="handleNodeCheck">
          <template slot-scope="{ data }">
            <div class="node-box">
              <div class="custom-tree-node-box">
                <div
                  class="common-checkbox-box"
                  v-if="!isShowCheckbox">
                  <el-checkbox
                    class="checkbox-primary"
                    @click.native="handleCheckBoxClick"
                    @change="value => handleCheckBoxChange(value, data)" />
                </div>
                <div
                  :class="getTreeNodeClassName(data)"
                  @mouseover="onNodeMouseOver(data)">
                  <Tooltip
                    :disabled="isTooltipDisabled(attrInfo)"
                    :attrInfo="attrInfo">
                    <div
                      v-if="data.editFlag && isSelected(data)"
                      class="rename-box">
                      <div class="common-input-box">
                        <el-input
                          class="input-primary"
                          size="small"
                          :maxlength="100"
                          :value="data.nodeName"
                          @input="value => editNodeName(data, value)"
                          autocomplete="off"
                          placeholder="请输入名称" />
                      </div>
                      <div class="action-button-box">
                        <i
                          class="el-icon-check submit-btn"
                          @click.stop="saveNodeName(data)" />
                        <i
                          class="el-icon-close cancel-btn"
                          @click.stop="cancelEditNodeName(data)" />
                      </div>
                    </div>
                    <div
                      v-else
                      ref="nodeRef">
                      <div class="node-content-box">
                        <div :class="getNodeLabelClassName(data)">
                          <div
                            class="icon-box"
                            v-if="data.nodeType !== 2">
                            <icon-svg :icon-class="getIcon(data)" />
                          </div>
                          <div
                            class="icon-box"
                            v-if="isConverting(data)">
                            <i
                              class="el-icon-loading"
                              title="转换中" />
                          </div>
                          <div
                            class="icon-box"
                            v-if="isConvertFail(data)">
                            <icon-svg
                              title="转换失败"
                              icon-class="ic--s-tishi" />
                          </div>
                          <div
                            class="icon-box"
                            v-if="
                              isLockedVisible(data) &&
                              !isConverting(data) &&
                              !isConvertFail(data) &&
                              !(data.viewStatus === 2)
                            ">
                            <icon-svg icon-class="ic-suoding" />
                          </div>
                          <div
                            class="icon-box"
                            v-if="data.viewStatus === 2 && data.disableReason">
                            <icon-svg
                              :title="data.disableReason"
                              icon-class="ic--s-tishi" />
                          </div>
                          <div
                            class="icon-box"
                            v-if="
                              data.hasUpdated &&
                              !isConverting(data) &&
                              !isConvertFail(data)
                            ">
                            <icon-svg icon-class="ic-jiancegengxin" />
                          </div>
                          <div class="label-box text-overflow">
                            {{ data.nodeName }}
                          </div>
                        </div>
                        <div
                          key="collapseIcon"
                          class="collapse-icon-box"
                          v-if="!isMutiMode">
                          <icon-svg
                            icon-class="icon-choutizhankai"
                            class="icon" />
                        </div>
                        <div
                          class="single-custom-button-box"
                          v-if="!isMutiMode">
                          <el-button
                            type="text"
                            size="small"
                            title="重命名"
                            :disabled="isBtnDisabled(data)"
                            v-if="isBtnVisible(data, 'renameNode')"
                            @click.stop="reNameNode(data)">
                            <icon-svg
                              icon-class="icon-xiugaimingcheng"
                              class="icon" />
                          </el-button>
                          <el-button
                            type="text"
                            size="small"
                            title="显示"
                            :disabled="isBtnDisabled(data)"
                            v-if="isBtnVisible(data, 'view')"
                            @click.stop="toggleView(data)">
                            <icon-svg
                              v-if="!isHidden(data)"
                              icon-class="icon-qiehuanyincang"
                              class="icon" />
                            <icon-svg
                              v-else
                              icon-class="icon-qiehuanxianshi-011"
                              class="icon" />
                          </el-button>
                          <el-button
                            type="text"
                            size="small"
                            title="新建文件夹"
                            v-if="isBtnVisible(data, 'addFolder')"
                            @click.stop="addFolderNode(data)">
                            <icon-svg
                              icon-class="icon-tianjiawenjianjia2"
                              class="icon" />
                          </el-button>
                          <el-button
                            type="text"
                            size="small"
                            title="移动到"
                            :disabled="isBtnDisabled(data)"
                            v-if="isBtnVisible(data, 'moveNode')"
                            @click.stop="openMoveDialog(data)">
                            <icon-svg
                              icon-class="icon-tuozhuaiyidong"
                              class="icon" />
                          </el-button>
                          <el-button
                            type="text"
                            size="small"
                            title="设置"
                            v-if="
                              isBtnVisible(data, 'prioritySetting') &&
                              data.isNew
                            "
                            :disabled="isBtnDisabled(data)"
                            @click.stop="openPrioritySettingPanel(data)">
                            <icon-svg
                              icon-class="icon-shezhi"
                              class="icon" />
                          </el-button>
                          <el-button
                            type="text"
                            size="small"
                            title="设置"
                            v-if="isBtnVisible(data, 'cadSetting')"
                            :disabled="isBtnDisabled(data)"
                            @click.stop="openCADSettingPanel(data)">
                            <icon-svg
                              icon-class="icon-shezhi"
                              class="icon" />
                          </el-button>
                          <el-button
                            type="text"
                            size="small"
                            title="设置"
                            v-if="isBtnVisible(data, 'vectorSetting')"
                            :disabled="isBtnDisabled(data)"
                            @click.stop="openVectorSettingPanel(data)">
                            <icon-svg
                              icon-class="icon-shezhi"
                              class="icon" />
                          </el-button>
                          <el-button
                            type="text"
                            size="small"
                            title="设置"
                            v-if="isBtnVisible(data, 'waterSetting')"
                            :disabled="isBtnDisabled(data)"
                            @click.stop="openEditWaterPanel(data)">
                            <icon-svg
                              icon-class="icon-shezhi"
                              class="icon" />
                          </el-button>
                          <el-button
                            type="text"
                            size="small"
                            title="设置"
                            v-if="isBtnVisible(data, 'extrudeSetting')"
                            :disabled="isBtnDisabled(data)"
                            @click.stop="openEditExtrudePanel(data)">
                            <icon-svg
                              icon-class="icon-shezhi"
                              class="icon" />
                          </el-button>
                          <el-button
                            type="text"
                            size="small"
                            title="方位编辑"
                            v-if="isBtnVisible(data, 'editPos')"
                            :disabled="isBtnDisabled(data)"
                            @click.stop="editPos(data)">
                            <icon-svg
                              icon-class="icon-fangweibianji-01"
                              class="icon" />
                          </el-button>
                          <el-button
                            type="text"
                            size="small"
                            title="删除"
                            v-if="isBtnVisible(data, 'deleteNode')"
                            :disabled="isConverting(data)"
                            @click.stop="deleteNode(data)">
                            <icon-svg
                              icon-class="icon-shanchu"
                              class="icon" />
                          </el-button>
                        </div>
                        <div
                          class="muti-custom-button-box"
                          v-if="isMutiMode && data.nodeType !== 2">
                          <el-button
                            v-if="isBtnVisible(data, 'editPos')"
                            type="text"
                            size="small"
                            title="位置编辑"
                            @click.stop="editPos(data)">
                            <icon-svg
                              icon-class="icon-fangweibianji-01"
                              class="icon" />
                          </el-button>
                          <el-button
                            type="text"
                            size="small"
                            title="新建文件夹"
                            @click.stop="addFolderNode(data)">
                            <icon-svg
                              icon-class="icon-tianjiawenjianjia2"
                              class="icon" />
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </Tooltip>
                </div>
              </div>
            </div>
          </template>
        </el-tree>
        <div class="temp-button-box">
          <div class="common-checkbox-box">
            <el-checkbox
              class="checkbox-primary"
              v-model="isFocus"
              >定位并高亮</el-checkbox
            >
          </div>
          <div
            class="custom-button-box"
            v-if="isMutiMode">
            <el-button
              type="text"
              size="small"
              title="显示"
              @click="e => mutiToggleView()">
              <icon-svg
                v-if="isMutiHidden"
                icon-class="icon-qiehuanxianshi-011"
                class="icon" />
              <icon-svg
                v-else
                icon-class="icon-qiehuanyincang"
                class="icon" />
            </el-button>
            <el-button
              type="text"
              size="small"
              title="移动到"
              @click="e => mutiMoveNode()">
              <icon-svg
                icon-class="icon-tuozhuaiyidong"
                class="icon" />
            </el-button>
            <el-button
              type="text"
              size="small"
              title="删除"
              @click="e => mutiDeleteNode()">
              <icon-svg
                icon-class="icon-shanchu"
                class="icon" />
            </el-button>
          </div>
        </div>
      </div>
      <div
        v-else
        class="common-empty-box">
        <bj-empty
          :image="require('@/assets/img/scene-no-data.png')"
          class="empty-page">
          <template slot="description">
            <div class="text-box">
              <div>点击顶部对应元素按钮</div>
              <div>添加数据集</div>
            </div>
          </template>
        </bj-empty>
      </div>
    </div>
  </div>
</template>

<script>
import Spin from '@/components/Spin.vue'
import Tooltip from './ToolTip.vue'

import { Store } from '@/utils/store'

import {
  addElemTreeNode,
  addSceneDirNodeService,
  motifySceneDataSetTreeNode,
  deleteSingleSceneTreeNode,
  getDastasetFiles,
  getElemInfo
} from '@/service/interface'
import { data } from 'jquery'

const elemDataSetType = [17, 18, 19]

const BtnList = [
  {
    name: '重命名',
    value: 'renameNode',
    nodeType: [1, 2],
    dataSetType: [0, 10, 11, 13, 15, 21, 19, 22, 23, 24],
    permissionCode: ''
  },
  {
    name: '显示/隐藏',
    value: 'view',
    nodeType: [1, 2, 3],
    dataSetType: [0, 10, 11, 13, 15, 21, 19, 22, 23, 24],
    permissionCode: ''
  },
  {
    name: '新建文件夹',
    value: 'addFolder',
    nodeType: [1, 3],
    dataSetType: [0, 10, 11, 13, 15, 21, 19, 22, 23, 24],
    permissionCode: ''
  },
  {
    name: '移动到',
    value: 'moveNode',
    nodeType: [1, 2],
    dataSetType: [0, 10, 11, 13, 15, 21, 19, 22, 23, 24],
    permissionCode: 'Project.Single.SceneTree.MoveNode'
  },
  {
    name: '设置',
    value: 'prioritySetting',
    nodeType: [2],
    dataSetType: [10, 13],
    permissionCode: ''
  },
  {
    name: '设置',
    value: 'cadSetting',
    nodeType: [2],
    dataSetType: [21],
    permissionCode: ''
  },
  {
    name: '设置',
    value: 'vectorSetting',
    nodeType: [2],
    dataSetType: [22],
    permissionCode: ''
  },
  {
    name: '设置',
    value: 'waterSetting',
    nodeType: [2],
    dataSetType: [23],
    permissionCode: ''
  },
  {
    name: '设置',
    value: 'extrudeSetting',
    nodeType: [2],
    dataSetType: [24],
    permissionCode: ''
  },
  {
    name: '方位编辑',
    value: 'editPos',
    nodeType: [2, 3],
    dataSetType: [0, 10, 11, 13, 15, 21, 19, 22],
    permissionCode: ''
  },
  {
    name: '删除',
    value: 'deleteNode',
    nodeType: [1, 2],
    dataSetType: [0, 10, 11, 13, 15, 21, 19, 22, 23, 24],
    permissionCode: 'Project.Single.SceneTree.DeleteNode'
  }
]

const dataTypeList = [
  {
    value: 'Bim',
    label: 'BIM模型',
    dataSetType: 0
  },
  {
    value: 'Rs',
    label: '遥感影像',
    dataSetType: 13
  },
  {
    value: 'Wmts',
    label: 'WMTS地图服务',
    dataSetType: 10
  },
  {
    value: 'Osgb',
    label: '倾斜摄影',
    dataSetType: 11
  },
  {
    value: 'PointCloud',
    label: '点云数据',
    dataSetType: 15
  },
  {
    value: 'Cad',
    label: '二维图纸',
    dataSetType: 16
  },
  {
    value: 'Entity',
    label: '构件',
    dataSetType: 17
  },
  {
    value: 'Entity',
    label: '构件',
    dataSetType: 18
  },
  {
    value: 'Entity',
    label: '构件',
    dataSetType: 19
  },
  {
    value: 'Vector',
    label: '矢量数据',
    dataSetType: 20
  }
]

export default {
  data() {
    return {
      sceneLoadFinish: false,
      isShowCheckbox: false,
      isMutiMode: false,
      defaultProps: {
        children: 'subNodes',
        label: 'nodeName'
      },
      attrInfo: {},
      attrCacheArray: [],

      newEntities: [], // 防止连续添加状态下，因接口未及时返回导致构件目录树重复

      selectNode: {}, // 重命名及新建文件夹时选中的节点

      hiddenNodes: [],

      isFocus: true,
      isMutiHidden: undefined // 多选模式下，显隐按钮状态
    }
  },
  props: {
    sceneInfo: Object,
    sceneData: Array,
    currDataSetFolder: Object,
    updateCurrDataSetFolder: Function,
    updateSceneTree: Function,
    elemAddMode: String,
    currEditElem: Object,
    updateCurrEditElem: Function,
    updateElemEditMode: Function,
    updateCurrEntity: Function,
    showBVShp: Function,
    unloadDataSets: Function,
    unloadEntities: Function,
    showDataSets: Function,
    hideDataSets: Function,
    highLightDataSets: Function,
    highLightEntities: Function,
    openMoveToDialog: Function,
    enterPosEditMode: Function,
    openPrioritySettingPanel: Function,
    openCADSettingPanel: Function,
    openVectorSettingPanel: Function,
    openEditWaterPanel: Function,
    openEditExtrudePanel: Function,
    highLightWaters: Function,
    showWaters: Function,
    hideWaters: Function,
    highLightExtrudes: Function,
    showExtrudes: Function,
    hideExtrudes: Function
  },
  components: {
    Spin,
    Tooltip
  },
  mounted() {
    this.$eventManage.on('dataSetLoadFinish', this.onDataSetLoadFinish)
    this.$eventManage.on('entityFinish', this.onEntityFinish)
    this.$eventManage.on('exitEntityEdit', this.onExitEntityEdit)
  },
  beforeDestroy() {
    this.$eventManage.off('dataSetLoadFinish', this.onDataSetLoadFinish)
    this.$eventManage.off('entityFinish', this.onEntityFinish)
    this.$eventManage.off('exitEntityEdit', this.onExitEntityEdit)
  },
  methods: {
    handleNodeClick(nodeData) {
      if (nodeData.editFlag) return

      if (nodeData.nodeType !== 2 && nodeData.nodeId !== 'tempNode') {
        let schemeType = this.getFolderSchemeType(nodeData)
        nodeData.schemeType = schemeType
        this.updateCurrDataSetFolder(nodeData)
      }

      if (this.isWaterNode(nodeData)) {
        this.highLightWaterList(nodeData)
        return
      }

      if (this.isExtrudeNode(nodeData)) {
        this.highLightExtrudeList(nodeData)
        return
      }

      if (this.isEntityNode(nodeData)) {
        window.BlackHole3D.BIM.setSelMode(1)
        this.highLightEntityList(nodeData)
      } else {
        window.BlackHole3D.BIM.setSelMode(0)
        this.highLightDataSetList(nodeData)
      }
    },
    handleNodeCheck() {
      let domRef = this.$refs.sceneDataTree

      let checkedKeys = domRef.getCheckedKeys()
      if (checkedKeys.length) {
        this.isMutiMode = true
      } else {
        this.isShowCheckbox = false
        this.isMutiMode = false
        this.isMutiHidden = false
      }
    },
    mutiToggleView() {
      const dataSetType = [0, 10, 11, 13, 15, 21, 19, 22]
      const waterType = [23]
      const extrudeType = [24]

      let domRef = this.$refs.sceneDataTree
      let checkedNodes = domRef.getCheckedNodes()
      let allLeafNodes = checkedNodes.filter(el => el.nodeType === 2)
      // prettier-ignore
      let allDataSets = allLeafNodes.filter(el => dataSetType.includes(el.dataSetType));
      let dataSets = allDataSets.map(item => {
        let dataSetId = ''
        if (elemDataSetType.includes(item.srcDataSetType)) {
          dataSetId = item.srcDataSetId.replaceAll('-', '')
        } else {
          dataSetId = item.dataSetId.replaceAll('-', '')
        }
        let obj = {
          dataSetId,
          dataSetType: item.srcDataSetType,
          elemId: item.elemId
        }
        return obj
      })
      // prettier-ignore
      let waterList = allLeafNodes.filter((el) => waterType.includes(el.dataSetType));
      let waterIds = waterList.map(item => item.waterId)
      // prettier-ignore
      let extrudeList = allLeafNodes.filter((el) => extrudeType.includes(el.dataSetType));
      let extrudeIds = extrudeList.map(item => item.extrudeId)

      if (!this.isMutiHidden) {
        this.isMutiHidden = true

        allLeafNodes.forEach(item => {
          let find = this.hiddenNodes.find(el => el === item.nodeId)
          if (!find) {
            this.hiddenNodes.push(item.nodeId)
          }
        })

        this.hideDataSets(dataSets)
        this.hideWaters(waterIds)
        this.hideExtrudes(extrudeIds)
      } else {
        this.isMutiHidden = false

        allLeafNodes.forEach(item => {
          let findIndex = this.hiddenNodes.findIndex(el => el === item.nodeId)
          if (findIndex !== -1) {
            this.hiddenNodes.splice(findIndex, 1)
          }
        })
        this.showDataSets(dataSets)
        this.showWaters(waterIds)
        this.showExtrudes(extrudeIds)
      }
    },
    mutiMoveNode() {
      let domRef = this.$refs.sceneDataTree
      let checkedNodes = domRef.getCheckedNodes()

      let dataSetTypes = []
      let dataTypeName = ''
      checkedNodes.forEach(item => {
        let levelCodes = item.levelCode.split('/')
        let findRootNode = this.findNodeById(this.sceneData, levelCodes[0])
        if (!dataSetTypes.includes(findRootNode.dataSetType)) {
          dataSetTypes.push(findRootNode.dataSetType)
          dataTypeName = findRootNode.nodeName
        }
      })

      if (dataSetTypes.length > 1) {
        this.$message.warning('所选数据类型不一致，请重新选择')
        return
      }

      let obj = {
        nodes: checkedNodes,
        dataTypeName,
        dataSetType: dataSetTypes[0]
      }
      this.openMoveToDialog(obj)
    },
    mutiDeleteNode() {
      let domRef = this.$refs.sceneDataTree
      let checkedNodes = domRef.getCheckedNodes()
      checkedNodes = checkedNodes.filter(el => el.nodeType !== 3)
      if (!checkedNodes.length) {
        this.$message.warning('数据根节点不可删除！')
        return
      }

      const dataSetType = [0, 10, 11, 13, 15, 21, 22]
      const entityType = [19]
      const waterType = [23]
      const extrudeType = [24]

      let allLeafNodes = checkedNodes.filter(el => el.nodeType === 2)

      let deleteTipMsg = '确认要删除所选中的数据集和场景对象?'
      this.$confirm(deleteTipMsg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let nodeIds = checkedNodes.map(item => item.nodeId)
          deleteSingleSceneTreeNode({ nodeIds }).then(response => {
            if (response.isSuccess) {
              this.$message.success('删除成功')

              let dataSetList = allLeafNodes.filter(item =>
                dataSetType.includes(item.dataSetType)
              )
              let dataSetIds = dataSetList.map(item => {
                let dataSetId = item.dataSetId
                dataSetId = dataSetId.replaceAll('-', '')
                return dataSetId
              })
              this.unloadDataSets(dataSetIds)

              let entityList = allLeafNodes.filter(item =>
                entityType.includes(item.dataSetType)
              )
              entityList.forEach(item => {
                this.unloadEntities(item)
              })

              let waterList = allLeafNodes.filter(item =>
                waterType.includes(item.dataSetType)
              )
              this.removeWaterList(waterList)

              let extrudeList = allLeafNodes.filter(item =>
                extrudeType.includes(item.dataSetType)
              )
              this.removeExtrudeList(extrudeList)

              nodeIds.forEach(item => {
                let findIndex = this.hiddenNodes.findIndex(el => item === el)
                if (findIndex !== -1) {
                  this.hiddenNodes.splice(findIndex, 1)
                }
              })
              this.updateSceneTree()
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    setCurrentKey(nodeId) {
      let domRef = this.$refs.sceneDataTree
      domRef && domRef.setCurrentKey(nodeId)
    },
    onDataSetLoadFinish() {
      let allRootNodes = this.findAllNodeByLevel(this.sceneData, 3)
      this.$nextTick(() => {
        let domRef = this.$refs.sceneDataTree
        allRootNodes.forEach(item => {
          let node = domRef.getNode(item.nodeId)
          node.expanded = true
        })

        setTimeout(() => {
          this.sceneLoadFinish = true
        }, 100)
      })
    },
    isEntityNode(nodeData) {
      let allData = this.findAllNodeByLevel([nodeData], 2)
      let isEntity = allData.every(el =>
        elemDataSetType.includes(el.srcDataSetType)
      )
      return isEntity
    },
    isWaterNode(nodeData) {
      let dataSetType = nodeData.dataSetType
      return dataSetType === 23
    },
    isExtrudeNode(nodeData) {
      let dataSetType = nodeData.dataSetType
      return dataSetType === 24
    },
    highLightWaterList(nodeData) {
      let waterList = this.findAllNodeByLevel([nodeData], 2)
      let waterIds = waterList.map(item => item.waterId)

      this.highLightWaters(waterIds)
    },
    highLightExtrudeList(nodeData) {
      let extrudeList = this.findAllNodeByLevel([nodeData], 2)
      let extrudeIds = extrudeList.map(item => item.extrudeId)

      this.highLightExtrudes(extrudeIds)
    },
    showWaterList(waterList) {
      waterList.forEach(item => {
        let findIndex = this.hiddenNodes.findIndex(el => el === item.nodeId)
        if (findIndex !== -1) {
          this.hiddenNodes.splice(findIndex, 1)
        }
      })

      let waterIds = waterList.map(item => item.waterId)
      this.showWaters(waterIds)
    },
    hideWaterList(waterList) {
      waterList.forEach(item => {
        let find = this.hiddenNodes.find(el => el === item.nodeId)
        if (!find) {
          this.hiddenNodes.push(item.nodeId)
        }
      })

      let waterIds = waterList.map(item => item.waterId)
      this.hideWaters(waterIds)
    },
    showExtrudeList(extrudeList) {
      extrudeList.forEach(item => {
        let findIndex = this.hiddenNodes.findIndex(el => el === item.nodeId)
        if (findIndex !== -1) {
          this.hiddenNodes.splice(findIndex, 1)
        }
      })

      let extrudeIds = extrudeList.map(item => item.extrudeId)
      this.showExtrudes(extrudeIds)
    },
    hideExtrudeList(extrudeList) {
      extrudeList.forEach(item => {
        let find = this.hiddenNodes.find(el => el === item.nodeId)
        if (!find) {
          this.hiddenNodes.push(item.nodeId)
        }
      })

      let extrudeIds = extrudeList.map(item => item.extrudeId)
      this.hideExtrudes(extrudeIds)
    },
    highLightDataSetList(nodeData) {
      let allDataSets = this.findAllNodeByLevel([nodeData], 2)
      allDataSets = allDataSets.filter(el => el.viewStatus !== 2)

      if (!allDataSets.length) {
        if (nodeData.nodeType !== 2) {
          this.$message.warning('当前节点下不存在有效的数据集，无法定位')
        } else {
          this.$message.warning('当前数据集已失效，无法定位')
        }
        return
      }

      let dataSets = allDataSets.map(item => {
        let dataSetId = item.dataSetId.replaceAll('-', '')
        let dataSetType = item.dataSetType
        let obj = { dataSetId, dataSetType }
        return obj
      })
      this.highLightDataSets(dataSets, this.isFocus)
    },
    highLightEntityList(nodeData) {
      let allDataSets = this.findAllNodeByLevel([nodeData], 2)
      let entities = []
      allDataSets.forEach(item => {
        let find = entities.find(el => el.dataSetId === item.srcDataSetId)
        if (find) {
          find.elemIds.push(item.elemId)
        } else {
          let obj = {
            dataSetId: item.srcDataSetId,
            elemIds: [item.elemId]
          }
          entities.push(obj)
        }
      })

      entities.forEach(item => {
        item.dataSetId = item.dataSetId.replaceAll('-', '')
      })

      this.highLightEntities(entities, this.isFocus)
    },
    toggleView(nodeData) {
      let leafNodes = this.findAllNodeByLevel([nodeData], 2)
      if (nodeData.dataSetType === 23) {
        if (this.isHidden(nodeData)) {
          this.showWaterList(leafNodes)
        } else {
          this.hideWaterList(leafNodes)
        }
        return
      }

      if (nodeData.dataSetType === 24) {
        if (this.isHidden(nodeData)) {
          this.showExtrudeList(leafNodes)
        } else {
          this.hideExtrudeList(leafNodes)
        }
        return
      }

      let allDataSets = this.findAllNodeByLevel([nodeData], 2)
      let dataSets = allDataSets.map(item => {
        let dataSetId = ''
        if (elemDataSetType.includes(item.srcDataSetType)) {
          dataSetId = item.srcDataSetId.replaceAll('-', '')
        } else {
          dataSetId = item.dataSetId.replaceAll('-', '')
        }
        let obj = {
          dataSetId,
          dataSetType: item.srcDataSetType,
          elemId: item.elemId
        }
        return obj
      })

      if (this.isHidden(nodeData)) {
        allDataSets.forEach(item => {
          let findIndex = this.hiddenNodes.findIndex(el => el === item.nodeId)
          if (findIndex !== -1) {
            this.hiddenNodes.splice(findIndex, 1)
          }
        })

        this.showDataSets(dataSets)
      } else {
        allDataSets.forEach(item => {
          let find = this.hiddenNodes.find(el => el === item.nodeId)
          if (!find) {
            this.hiddenNodes.push(item.nodeId)
          }
        })
        this.hideDataSets(dataSets)
      }
    },
    addFolderNode(nodeData) {
      if (this.selectNode.editFlag) {
        let message = '存在正在编辑的节点，请先编辑完成。'
        this.$message.warning(message)
        return
      }

      let domRef = this.$refs.sceneDataTree
      let node = domRef.getNode(nodeData.nodeId)
      if (node && node.level > window.maxLevel) {
        this.$message.warning(`最多只支持${window.maxLevel + 1}级`)
        return false
      }

      let newNodeData = {
        nodeId: 'tempNode',
        nodeName: '',
        nodeType: 1,
        subNodes: [],
        editFlag: true,
        isNewNode: true,
        dataSetType: this.getFolderDataSetType(nodeData)
      }

      newNodeData.parentId = nodeData.nodeId
      newNodeData.levelCode = `${nodeData.levelCode}/${newNodeData.nodeId}`
      nodeData.subNodes.push(newNodeData)
      this.selectNode = newNodeData
      this.$nextTick(() => {
        let node = domRef.getNode(nodeData.nodeId)
        node.expanded = true
      })
    },
    reNameNode(nodeData) {
      if (this.selectNode.editFlag) {
        let nodeName = this.selectNode.nodeName
        let message = `${nodeName}正在编辑，请先编辑完成。`
        this.$message.warning(message)
        return
      }
      this.$set(nodeData, 'editFlag', true)
      this.selectNode = nodeData
    },
    deleteNode(nodeData) {
      let deleteTipMsg = this.getDeleteTipMsg(nodeData)
      this.$confirm(deleteTipMsg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = { nodeIds: [nodeData.nodeId] }
          deleteSingleSceneTreeNode(params).then(response => {
            if (response.isSuccess) {
              this.$message.success('删除成功')

              if (nodeData.dataSetType === 19) {
                this.removeEntities(nodeData)
              }

              if (nodeData.dataSetType === 23) {
                let waterList = this.findAllNodeByLevel([nodeData], 2)
                this.removeWaterList(waterList)
              }

              if (nodeData.dataSetType === 24) {
                let extrudeList = this.findAllNodeByLevel([nodeData], 2)
                this.removeExtrudeList(extrudeList)
              }

              // 不需要卸载数据集的类型
              let dataSetTypes = [19, 23, 24]
              if (!dataSetTypes.includes(nodeData.dataSetType)) {
                this.removeDataSets(nodeData)
              }

              let folderNodes = this.findAllNodeByLevel([nodeData], 1)
              let dataSetNodes = this.findAllNodeByLevel([nodeData], 2)
              let checkedNodes = [...folderNodes, ...dataSetNodes]
              checkedNodes.forEach(item => {
                let findIndex = this.hiddenNodes.findIndex(
                  el => item.nodeId === el
                )
                if (findIndex !== -1) {
                  this.hiddenNodes.splice(findIndex, 1)
                }
              })
              this.updateSceneTree()
            } else {
              this.$message.error(response.errMsg)
            }
          })
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    editNodeName(nodeData, value) {
      this.$set(nodeData, 'nodeName', value)
    },
    saveNodeName(nodeData) {
      let value = nodeData.nodeName

      if (!value.length) {
        this.$message.warning('名称不能为空')
        return
      }

      if (value.length !== value.trimStart().trimEnd().length) {
        this.$message.warning('开头和结尾不允许有空格')
        return
      }

      let wordLimit = [
        {
          dataSetType: [23, 24],
          minLength: 1,
          maxLength: 20,
          message: '输入内容请控制在1到20个字符之间'
        },
        {
          dataSetType: [0, 10, 11, 13, 15, 21, 19, 22],
          minLength: 1,
          maxLength: 100,
          message: '名称最多支持100个字符'
        }
      ]
      let find = wordLimit.find(item =>
        item.dataSetType.includes(nodeData.dataSetType)
      )
      if (value.length < find.minLength || value.length > find.maxLength) {
        this.$message.warning(find.message)
        return
      }

      if (nodeData.isNewNode) {
        let sceneId = this.$route.query.sceneId
        let params = {
          sceneId,
          parentId: nodeData.parentId,
          nodeName: nodeData.nodeName
        }
        addSceneDirNodeService(params).then(response => {
          if (response.isSuccess) {
            this.updateSceneTree().then(() => {
              const domRef = this.$refs.sceneDataTree.$el
              const scrollTop = domRef.scrollTop

              this.$nextTick(() => {
                this.$set(nodeData, 'editFlag', false)
                setTimeout(() => {
                  domRef.scrollTop = scrollTop
                }, 0)
              })
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      } else {
        if (nodeData.nodeName === nodeData.sceneNodeName) {
          this.$nextTick(() => {
            this.$set(nodeData, 'editFlag', false)
          })
          return
        }

        let params = {
          nodeId: nodeData.nodeId,
          nodeName: nodeData.nodeName
        }
        motifySceneDataSetTreeNode(params).then(response => {
          if (response.isSuccess) {
            this.updateSceneTree().then(() => {
              const domRef = this.$refs.sceneDataTree.$el
              const scrollTop = domRef.scrollTop
              this.$nextTick(() => {
                this.$set(nodeData, 'editFlag', false)
                setTimeout(() => {
                  domRef.scrollTop = scrollTop
                }, 0)
              })
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      }
    },
    cancelEditNodeName(nodeData, e) {
      let domRef = this.$refs.sceneDataTree
      let node = domRef.getNode(nodeData.nodeId)
      let parentNode = node.parent
      if (nodeData.isNewNode) {
        let findIndex = parentNode.childNodes.findIndex(el => el.id === node.id)
        if (findIndex !== -1) {
          parentNode.childNodes.splice(findIndex, 1)
        }
        let subNodes = []
        parentNode.childNodes.forEach(item => {
          subNodes.push(item.data)
        })
        node.parent.data.subNodes = subNodes

        this.selectNode = {}
      } else {
        let parentNodeData = parentNode.data
        let find = this.findNodeById([parentNodeData], nodeData.nodeId)
        if (find) {
          this.$set(nodeData, 'nodeName', find.sceneNodeName)
          this.$set(nodeData, 'editFlag', false)
        }
      }
    },
    getFolderSchemeType(nodeData) {
      if (!nodeData.levelCode) return

      let levelCodes = nodeData.levelCode.split('/')
      let findRootNode = this.findNodeById(this.sceneData, levelCodes[0])
      let find = dataTypeList.find(
        el => el.dataSetType === findRootNode.srcDataSetType
      )

      if (find) {
        return find.value
      }
    },
    openMoveDialog(nodeData) {
      let levelCodes = nodeData.levelCode.split('/')
      let find = this.findNodeById(this.sceneData, levelCodes[0])

      let allFolders = this.findAllNodeByLevel([nodeData], 1)
      let allDataSets = this.findAllNodeByLevel([nodeData], 2)
      let nodes = [...allFolders, ...allDataSets]
      let obj = {
        nodes,
        dataSetType: find.dataSetType,
        dataTypeName: find.nodeName
      }

      this.openMoveToDialog(obj)
    },
    onEntityFinish() {
      if (!this.elemAddMode) return

      const BlackHole3D = window.BlackHole3D

      let dataSetId = this.currEditElem.dataSetId
      dataSetId = dataSetId.replaceAll('-', '')
      let entities = BlackHole3D.Entity.getEntitys(dataSetId, '')
      if (!entities.length) {
        this.$message.warning('您没有添加任何构件')
        return
      }

      let newEntityArray = []
      let currFileId = this.currEditElem.id
      let parentId = this.getParentNodeId()
      entities.forEach(item => {
        let isEntityExist = this.isEntityExist(item)
        if (!isEntityExist) {
          let obj = {
            parentId,
            dataSetId: this.currEditElem.dataSetId,
            fileId: currFileId,
            dataSetType: this.currEditElem.dataSetType,
            playMode: 'REPEAT',
            elemId: item.elemId,
            dataSetCrs: item.dataSetCRS,
            scale: JSON.stringify(item.scale),
            rotate: JSON.stringify(item.rotate),
            translation: JSON.stringify(item.offset)
          }
          newEntityArray.push(obj)
          this.newEntities.push(item)

          let currEditElem = this.currEditElem
          currEditElem.elemId = item.elemId
          this.updateCurrEditElem(currEditElem)
          this.setDefaultAnim(item)
        }
      })

      setTimeout(() => {
        let sceneId = this.$route.query.sceneId
        let params = { sceneId, items: newEntityArray }
        addElemTreeNode(params).then(response => {
          if (response.isSuccess) {
            this.updateSceneTree().then(() => {
              this.expandNodeByDataSetType(19)

              let elemId = newEntityArray.pop().elemId
              let currEntity = this.getCurrEntity(elemId)

              this.updateCurrEntity(currEntity)
              this.showBVShp(dataSetId, elemId)
              this.updateElemEditMode('')
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      }, 500)
    },
    getParentNodeId() {
      let currDataSetFolder = this.currDataSetFolder
      let parentNodeId = undefined
      if (currDataSetFolder.schemeType === 'Entity') {
        parentNodeId = currDataSetFolder.nodeId
      }
      return parentNodeId
    },
    getCurrEntity(elemId) {
      let allDataSets = this.findAllNodeByLevel(this.sceneData, 2)
      let allEntities = allDataSets.filter(el =>
        elemDataSetType.includes(el.srcDataSetType)
      )
      let currEntity = allEntities.find(el => {
        let dateSetId = this.currEditElem.dataSetId
        let find = dateSetId === el.srcDataSetId && elemId === el.elemId
        return find
      })
      return currEntity
    },
    isEntityExist(entityInfo) {
      let allDataSets = this.findAllNodeByLevel(this.sceneData, 2)
      let allEntities = allDataSets.filter(
        el => el.srcDataSetType === 17 || el.srcDataSetType === 18
      )

      let find1 = this.newEntities.find(
        el =>
          el.dataSetId === entityInfo.dataSetId &&
          el.elemId === entityInfo.elemId
      )
      let find2 = allEntities.find(item => {
        let dataSetId = item.srcDataSetId
        dataSetId = dataSetId.replaceAll('-', '')
        if (
          dataSetId === entityInfo.dataSetId &&
          item.elemId === entityInfo.elemId
        ) {
          return true
        } else {
          return false
        }
      })

      let isEntityExist = true
      if (!find1 && !find2) {
        isEntityExist = false
      }
      return isEntityExist
    },
    setDefaultAnim(entity) {
      const BlackHole3D = window.BlackHole3D
      const AnimPlayModeEm = BlackHole3D.REEntityAnimPlayModeEm
      const AnimPlayStateEm = BlackHole3D.REEntityAnimPlayStateEm

      let animPlayInfo = new BlackHole3D.REEntityAnimPlayInfo()
      animPlayInfo.dataSetId = entity.dataSetId
      animPlayInfo.entityType = entity.entityType
      animPlayInfo.elemIdList = [entity.elemId]
      animPlayInfo.animPlayMode = AnimPlayModeEm.REPEAT
      animPlayInfo.animPlayState = AnimPlayStateEm.PLAY
      BlackHole3D.Entity.setAnimPlayMode(animPlayInfo)
    },
    onExitEntityEdit() {
      this.newEntities = []
    },
    editPos(nodeData) {
      let nodeType = nodeData.nodeType
      let currPosEditDataSetType = nodeData.dataSetType
      let domRef = this.$refs.sceneDataTree
      if (nodeType === 2) {
        if (this.isLockedVisible(nodeData)) {
          let warnMsg = '当前选中数据集是通过坐标参考配置方位，不支持位置编辑'
          this.$message.warning(warnMsg)
          return
        }

        let expandNodeKeys = this.getExpandNodeKeys()
        let selectedDataSets = [nodeData]
        let posEditInfo = {
          dataSetType: currPosEditDataSetType,
          expandNodeKeys,
          selectedDataSets
        }
        this.enterPosEditMode(posEditInfo)
      } else {
        let checkedNodes = domRef.getCheckedNodes()
        checkedNodes = checkedNodes.filter(
          el => el.dataSetType === nodeData.dataSetType
        )

        let dataSets = checkedNodes.filter(el => el.nodeType === 2)
        let isAllEditDisabled = dataSets.every(
          el => this.isLockedVisible(el) || this.isBtnDisabled(el)
        )
        if (isAllEditDisabled) {
          this.$message.warning('当前选中的数据集均不可编辑，请重新选择')
          return
        }

        // prettier-ignore
        let isDistanceCheckPass = this.isDistanceCheckPass(currPosEditDataSetType, dataSets);
        if (!isDistanceCheckPass) {
          // prettier-ignore
          let warningMsg ="当前选中的数据集之间距离太远，不可同时编辑，请重新选择";
          this.$message.warning(warningMsg)
          return
        }

        let expandNodeKeys = this.getExpandNodeKeys()
        let posEditInfo = {
          dataSetType: currPosEditDataSetType,
          expandNodeKeys,
          selectedDataSets: dataSets
        }
        this.enterPosEditMode(posEditInfo)
      }

      domRef.setCheckedKeys([])
      this.isShowCheckbox = false
      this.isMutiMode = false
      this.isMutiHidden = false
    },
    isDistanceCheckPass(currPosEditDataSetType, dataSets) {
      // 因引擎暂不支持获取不同类型单钩件的包围盒大小，因此单钩件编辑暂时跳过距离检验
      if (elemDataSetType.includes(currPosEditDataSetType)) {
        return true
      }

      const maxDistance = 1000000 // 距离阈值 1000公里
      let totalBBoxInfo = this.getTotalBBoxInfo(dataSets)
      let isLengthPass = totalBBoxInfo[0] < maxDistance ? true : false
      let isWidthPass = totalBBoxInfo[1] < maxDistance ? true : false
      let isHeightPass = totalBBoxInfo[2] < maxDistance ? true : false

      if (isLengthPass && isWidthPass && isHeightPass) {
        return true
      } else {
        return false
      }
    },
    getTotalBBoxInfo(dataSets) {
      let xValue = []
      let yValue = []
      let zValue = []

      const BlackHole3D = window.BlackHole3D
      dataSets.forEach(item => {
        let bbox
        let dataSetId = item.dataSetId.replaceAll('-', '')
        if (item.dataSetType === 0) {
          bbox = BlackHole3D.BIM.getTotalBV(dataSetId)
        } else {
          bbox = BlackHole3D.Grid.getDataSetBV(dataSetId)
        }
        xValue.push(bbox[0], bbox[1])
        yValue.push(bbox[2], bbox[3])
        zValue.push(bbox[4], bbox[5])
      })

      let bboxLength = Math.max(...xValue) - Math.min(...xValue)
      let bboxWidth = Math.max(...yValue) - Math.min(...yValue)
      let bboxHeight = Math.max(...zValue) - Math.min(...zValue)

      return [bboxLength, bboxWidth, bboxHeight]
    },
    handleCheckBoxClick(e) {
      e && e.stopPropagation()
    },
    handleCheckBoxChange(value, nodeData) {
      if (value) {
        this.isShowCheckbox = true
        this.isMutiMode = true

        let domRef = this.$refs.sceneDataTree
        domRef.setCurrentKey(null)
        domRef.setCheckedKeys([nodeData.nodeId])
      }
    },
    onNodeMouseOver(nodeData) {
      if (this.attrInfo.id !== nodeData.nodeId) {
        let dom = document.querySelector('.common-panel-right-tooltip-box')
        dom && dom.remove()
        this.attrInfo = {}
      }
      if (nodeData.dataSetType === 23 || nodeData.dataSetType === 24) {
        this.attrInfo = {
          name: nodeData?.nodeName ?? '-',
          showOnlyName: true
        }
        return
      }

      let nodeType = nodeData.nodeType
      if (nodeType !== 2) return

      let id = nodeData.sceneNodeId
      let find = this.attrCacheArray.find(el => el.id === id)
      if (find) {
        this.attrInfo = find.attrInfo
        return
      }

      if (this.isEntityNode(nodeData)) {
        let params = { nodeId: nodeData.sceneNodeId }
        getElemInfo(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            if (data) {
              let attrInfo = {
                id: nodeData.nodeId,
                attrType: 'elem',
                name: data.displayName,
                fileType: data.fileExtension,
                length: data.fileSize,
                srcName: data.srcName
              }
              this.attrInfo = attrInfo
              this.attrCacheArray.push({ id: nodeData.sceneNodeId, attrInfo })
            }
          } else {
            this.$message.error(response.errMsg)
          }
        })
      } else {
        let params = { dataSetId: nodeData.srcDataSetId }
        getDastasetFiles(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let dataType = dataTypeList.find(
              el => el.dataSetType === nodeData.srcDataSetType
            )
            let attrInfo = {
              id: nodeData.nodeId,
              attrType: 'dataSet',
              name: nodeData.nodeName,
              dataType: dataType.label,
              length: data.size,
              path: nodeData.levelPathName,
              sourcePath: data.sourcePathName,
              subItems: data.dataSetFileNames
            }
            this.attrCacheArray.push({ id: nodeData.sceneNodeId, attrInfo })
            this.attrInfo = attrInfo
          } else {
            this.$message.error(response.errMsg)
          }
        })
      }
    },
    findAllNodeByLevel(data, level) {
      const array = []

      const traverse = item => {
        if (item.nodeType === level) {
          array.push(item)
        }
        if (item.subNodes && item.subNodes.length) {
          item.subNodes.forEach(subNode => {
            traverse(subNode)
          })
        }
      }

      data.forEach(item => {
        traverse(item)
      })

      return array
    },
    findNodeById(data, id) {
      for (const node of data) {
        if (node.nodeId === id) return node
        if (node.subNodes && node.subNodes.length) {
          const res = this.findNodeById(node.subNodes, id)
          if (res) return res
        }
      }
      return null
    },
    getAllFormatedDataSets(nodeData) {
      let dataSets = []
      let allDataSets = this.findAllNodeByLevel([nodeData], 2)
      allDataSets.forEach(item => {
        if (elemDataSetType.includes(item.dataSetType)) {
          let dataSetId = item.srcDataSetId.replaceAll('-', '')
          let find = dataSets.find(el => el.dataSetId === dataSetId)
          if (find) {
            find.elemIdList.push(item.elemId)
          } else {
            let obj = {
              dataSetId,
              dataSetType: item.dataSetType,
              elemIdList: [item.elemId]
            }
            dataSets.push(obj)
          }
        } else {
          let dataSetId = item.dataSetId.replaceAll('-', '')
          let obj = {
            dataSetId,
            dataSetType: item.dataSetType,
            elemIdList: []
          }
          dataSets.push(obj)
        }
      })
      return dataSets
    },
    getDeleteTipMsg(nodeData) {
      let { nodeType, srcDataSetType } = nodeData
      let typeName = ''
      if (elemDataSetType.includes(srcDataSetType)) {
        typeName = '构件'
      } else {
        typeName = '数据集'
      }

      if (nodeData.dataSetType === 23) {
        typeName = '水面'
      }

      if (nodeData.dataSetType === 24) {
        typeName = '开挖'
      }

      let msg = ''
      if (nodeType === 1) {
        msg = `该操作将删除当前分组以及分组下的所有${typeName}，是否继续?`
      } else {
        msg = `确定要删除当前${typeName}吗?`
      }
      return msg
    },
    removeDataSets(nodeData) {
      let nodeType = nodeData.nodeType
      let allDatasets = []
      if (nodeType === 1) {
        allDatasets = this.findAllNodeByLevel([nodeData], 2)
      } else {
        allDatasets = [nodeData]
      }
      let dataSetIds = allDatasets.map(item => {
        let dataSetId = item.dataSetId
        dataSetId = dataSetId.replaceAll('-', '')
        return dataSetId
      })
      this.unloadDataSets(dataSetIds)
    },
    removeEntities(nodeData) {
      let nodeType = nodeData.nodeType

      let allEntities = []
      if (nodeType === 1) {
        allEntities = this.findAllNodeByLevel([nodeData], 2)
      } else {
        allEntities = [nodeData]
      }
      allEntities.forEach(item => {
        this.unloadEntities(item)
      })
    },
    removeWaterList(waterList) {
      let waterIds = waterList.map(item => item.waterId)

      const BlackHole3D = window.BlackHole3D
      if (waterList.length) {
        BlackHole3D.Water.delData(waterIds)
      }
    },
    removeExtrudeList(extrudeList) {
      let extrudeIds = extrudeList.map(item => item.extrudeId)

      const BlackHole3D = window.BlackHole3D
      if (extrudeIds.length) {
        BlackHole3D.Extrude.delData(extrudeIds)
      }
    },
    getExpandNodeKeys() {
      let domRef = this.$refs.sceneDataTree
      let nodesMap = domRef.store.nodesMap

      let expandNodeKeys = []
      for (let key in nodesMap) {
        let expand = nodesMap[key].expanded
        if (expand) {
          expandNodeKeys.push(key)
        }
      }

      return expandNodeKeys
    },
    setExpandNodes() {
      let domRef = this.$refs.sceneDataTree
      if (!domRef) return
      let nodesMap = domRef.store.nodesMap

      let expandNodes = []
      for (let key in nodesMap) {
        let expand = nodesMap[key].expanded
        if (expand) {
          expandNodes.push(key)
        }
      }

      this.$nextTick(() => {
        expandNodes.forEach(item => {
          nodesMap[item].expanded = true
        })
      })
    },
    expandNodeByDataSetType(dataSetType) {
      let domRef = this.$refs.sceneDataTree
      if (!domRef) return

      let allRootNodes = this.findAllNodeByLevel(this.sceneData, 3)
      let nodeData = allRootNodes.find(el => el.dataSetType === dataSetType)
      this.$nextTick(() => {
        let nodeObject = domRef.getNode(nodeData.nodeId)
        nodeObject.expanded = true
      })
    },
    setCheckedNodes() {
      let domRef = this.$refs.sceneDataTree
      if (!domRef) return

      let nodesMap = domRef.store.nodesMap

      let checkedNodes = []
      let indeterminateNodes = []
      for (let key in nodesMap) {
        let checked = nodesMap[key].checked
        if (checked) {
          checkedNodes.push(key)
        }
        let indeterminate = nodesMap[key].indeterminate
        if (indeterminate) {
          indeterminateNodes.push(key)
        }
      }

      this.$nextTick(() => {
        checkedNodes.forEach(item => {
          let childNodes = nodesMap[item].childNodes
          let childChecked = childNodes.length
            ? childNodes.every(el => el.checked)
            : false
          if (childChecked) {
            nodesMap[item].checked = true
          }
        })
        indeterminateNodes.forEach(item => {
          let childNodes = nodesMap[item].childNodes
          let childIndeterminate = childNodes.some(el => el.checked)
          let childChecked = childNodes.length
            ? childNodes.every(el => el.checked)
            : false
          if (childIndeterminate && !childChecked) {
            nodesMap[item].indeterminate = true
          }
        })
      })
    },
    isHidden(nodeData) {
      let isHidden = false
      let nodeType = nodeData.nodeType
      if (nodeType === 2) {
        if (this.hiddenNodes.includes(nodeData.nodeId)) {
          isHidden = true
        } else {
          isHidden = false
        }
      } else {
        let allDataSets = this.findAllNodeByLevel([nodeData], 2)
        if (!allDataSets.length) {
          isHidden = true
        } else {
          isHidden = allDataSets.every(el =>
            this.hiddenNodes.includes(el.nodeId)
          )
        }
      }
      return isHidden
    },
    isBtnVisible(nodeInfo, btnName) {
      let visible = false
      let nodeType = nodeInfo.nodeType
      let find = BtnList.find(el => el.value === btnName)
      if (find.nodeType.includes(nodeType)) {
        visible = true
      }

      if (visible && find.dataSetType) {
        visible = find.dataSetType.includes(nodeInfo.dataSetType)
      }

      if (visible && find.permissionCode) {
        visible = this.isChecked(find.permissionCode)
      }

      return visible
    },
    isBtnDisabled(data) {
      let isDisabled = false
      if (this.isConverting(data)) {
        isDisabled = true
      }

      if (data.viewStatus === 2) {
        isDisabled = true
      }

      return isDisabled
    },
    isLockedVisible(data) {
      let visible = false

      if (data.nodeType !== 2) {
        visible = false
        return
      }

      if (this.sceneInfo.coordinates) {
        let srcDataSetType = data.srcDataSetType
        if (srcDataSetType === 10 || srcDataSetType === 13) {
          visible = true
        }

        if (srcDataSetType === 16 || srcDataSetType === 20) {
          if (data.isTouchDown) {
            visible = true
          }
        }
      }

      return visible
    },
    isConverting(data) {
      const convertingStatus = [0, 1, 2, 6]
      return convertingStatus.includes(data.status)
    },
    isConvertFail(data) {
      const converFailStatus = [4]
      return data.viewStatus === 2 && converFailStatus.includes(data.status)
    },
    getTreeNodeClassName(nodeInfo) {
      let className = 'custom-node-box'

      let viewStatus = nodeInfo.viewStatus
      if (viewStatus === 2) {
        className += ' node-disabled'
      }
      return className
    },
    getNodeLabelClassName(nodeInfo) {
      let nodeType = nodeInfo.nodeType
      let className = 'node-label-box'

      if (nodeType === 3) {
        className += ' node-label-bold'
      }

      return className
    },
    getIcon(nodeInfo) {
      let nodeType = nodeInfo.nodeType
      if (nodeType === 1) return 'ic-ico_folder'

      let srcDataSetType = nodeInfo.srcDataSetType
      switch (srcDataSetType) {
        case 0:
          return 'ic-moxing'
        case 13:
          return 'ic-yg'
        case 10:
          return 'ic-WMTS'
        case 11:
          return 'ic-qxsy'
        case 15:
          return 'ic-dy'
        case 16:
          return 'ic-CADwapian'
        case 17:
          return 'ic-yuanjian'
        case 18:
          return 'ic-yuanjian'
        case 19:
          return 'ic-yuanjian'
        case 20:
          return 'ic-shiliangwapian-2'
        case 23:
          return 'ic-shuimian'
        case 24:
          return 'ic-kaiwa'
      }
    },
    isSelected(nodeData) {
      return this.selectNode.nodeId === nodeData.nodeId
    },
    isTooltipDisabled(attrInfo) {
      let isDisabled = Object.keys(attrInfo).length ? false : true
      return isDisabled
    },
    getFolderDataSetType(nodeData) {
      if (!nodeData.levelCode) return

      let levelCodes = nodeData.levelCode.split('/')
      let findRootNode = this.findNodeById(this.sceneData, levelCodes[0])
      return findRootNode.dataSetType
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },

    focusToData(nodeData, e) {
      if (this.isEntityNode(nodeData)) {
        this.focusToEntityList(nodeData)
      } else {
        this.focusToDataSetList(nodeData)
      }
    },
    focusToDataSetList(nodeData) {
      let nodeType = nodeData.nodeType
      if (nodeType === 2) {
        let dataSetId = nodeData.dataSetId.replaceAll('-', '')
        let dataSets = [{ dataSetId }]
        this.focusDataSets(dataSets)
      } else {
        let allDataSets = this.findAllNodeByLevel([nodeData], 2)

        let dataSets = allDataSets.map(item => {
          let dataSetId = item.dataSetId.replaceAll('-', '')
          return { dataSetId }
        })
        this.focusDataSets(dataSets)
      }
    },
    focusToEntityList(nodeData) {
      let nodeType = nodeData.nodeType
      if (nodeType === 2) {
        let dataSetId = nodeData.srcDataSetId.replaceAll('-', '')
        let entities = [
          {
            dataSetId,
            elemIds: [nodeData.elemId]
          }
        ]
        this.focusEntities(entities)
      } else {
        let allDataSets = this.findAllNodeByLevel([nodeData], 2)
        let entities = []
        allDataSets.forEach(item => {
          let find = entities.find(el => el.dataSetId === item.srcDataSetId)
          if (find) {
            find.elemIds.push(item.elemId)
          } else {
            let obj = {
              dataSetId: item.srcDataSetId,
              elemIds: [item.elemId]
            }
            entities.push(obj)
          }
        })

        entities.forEach(item => {
          item.dataSetId = item.dataSetId.replaceAll('-', '')
        })

        this.focusEntities(entities)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.scene-data-container {
  position: relative;
  width: 320px;
  height: 100%;
  padding: 15px;
  // border-top: 1px solid var(--scene-edit-header-border-color);
  background: var(--side-bg-color);
  // border-right: 1px solid var(--scene-edit-header-border-color);

  .spin-box {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .scene-data-box {
    height: calc(100% - 30px);

    .common-tree-box {
      height: 100%;
      font-size: 14px;

      :deep(.el-tree-node__expand-icon) {
        margin-top: 0;
      }

      :deep(.el-tree-node__content:has(.single-custom-button-box)) {
        &:hover {
          background: var(--scene-edit-left-tree-icon-bgColor);
        }
      }

      :deep(.el-tree > .is-current > .el-tree-node__content) {
        .node-label-box {
          .label-box {
            color: var(--base-primary-bgColor) !important;
          }
        }
        .node-content-box {
          .single-custom-button-box {
            background: var(--scene-edit-left-tree-icon-bgColor);
          }
        }
      }

      :deep(
          .el-tree
            .el-tree-node__children
            > .is-current
            > .el-tree-node__content
        ) {
        .node-label-box {
          .label-box {
            color: var(--base-primary-bgColor) !important;
          }
        }
        .node-content-box {
          .single-custom-button-box {
            background: var(--scene-edit-left-tree-icon-bgColor);
          }
        }
      }

      :deep(.el-tree) {
        .collapse-transition {
          transition: none !important;
        }

        .el-tree-node {
          position: relative;

          &:not(:first-child) {
            margin-top: 4px;
          }

          .el-tree-node__content {
            margin-left: 20px;

            &:hover {
              .common-checkbox-box {
                opacity: 1;
              }
            }

            .el-checkbox {
              position: absolute;
              left: 0px;
              top: 3px;
              border: 1px solid transparent;
              line-height: 12px;
            }
          }
        }
      }

      .node-box {
        display: flex;
        flex-grow: 1;
        overflow: hidden;
        height: 26px;
        line-height: 26px;
      }

      .custom-tree-node-box {
        display: flex;
        flex-grow: 1;
        overflow: hidden;

        .common-checkbox-box {
          margin-right: -2px;
          opacity: 0;
          border: 1px solid transparent;
          transition: opacity 0.1s ease-out;

          &:hover {
            opacity: 1;
          }
        }

        .node-disabled {
          opacity: 0.5;
        }

        .custom-node-box {
          position: relative;
          flex-grow: 1;
          padding: 0px 5px;
          overflow: hidden;

          .rename-box {
            display: flex;
            width: 100%;

            .common-input-box {
              flex-grow: 1;
              display: flex;
              align-items: center;

              /deep/ .el-input__inner {
                height: 25px;
                line-height: 25px;
              }
            }

            .action-button-box {
              margin: 0px 10px;
              line-height: 26px;

              .submit-btn {
                color: #00e005;
              }

              .cancel-btn {
                margin-left: 10px;
                color: #ff2626;
              }
            }
          }

          .node-content-box {
            display: flex;
            justify-content: space-between;

            .node-label-box {
              display: flex;
              align-items: center;
              overflow: hidden;

              .label-box {
                margin-left: 5px;
                font-size: 14px;
                font-weight: 400;
                color: var(--scene-edit-left-tree-text-color);
              }
            }

            .node-label-bold {
              font-weight: bold;
            }

            .collapse-icon-box {
              display: none;
              padding: 0px 5px;
              margin-top: 2px;
              color: var(--scene-edit-left-tree-icon-color);
              transform: translate(0px, 0px);
              .icon {
                &:hover {
                  :deep(use) {
                    color: var(--base-primary-bgColor);
                  }
                }
              }
              &:hover {
                transform: translate(20px, 0px);
              }

              &:hover + .single-custom-button-box {
                display: block;
              }
            }

            .single-custom-button-box {
              position: absolute;
              display: none;
              width: 100%;
              height: 26px;
              line-height: 28px;
              left: 1px;
              top: 0;
              padding: 0px 10px;
              text-align: right;
              border-radius: 8px;
              background: var(--scene-edit-left-tree-icon-bgColor);

              &:hover {
                display: block;
              }

              .el-button {
                margin-left: 5px;
                margin-right: 0px;
                padding: 0px;
              }

              .icon {
                font-size: 18px;
                color: var(--default-color);

                &:hover {
                  :deep(use) {
                    color: var(--base-primary-bgColor);
                  }
                }
              }
            }

            .muti-custom-button-box {
              padding: 0px 10px;

              .el-button {
                margin-left: 5px;
                margin-right: 0px;
                padding: 0px;
              }

              .icon {
                font-size: 14px;
                color: var(--default-color);
              }
            }
          }

          &:hover {
            .node-content-box {
              .collapse-icon-box {
                display: block;
                display: flex;
                align-items: center;
              }
            }
          }
        }
      }
    }

    .temp-button-box {
      position: absolute;
      display: flex;
      justify-content: space-between;
      width: 100%;
      left: 0px;
      bottom: 0px;
      line-height: 32px;
      padding: 5px 15px;
      border-top: 1px solid var(--scene-edit-header-border-color);
      background: var(--side-bg-color);

      .custom-button-box {
        padding: 0px 10px;

        .el-button {
          margin-right: 0px;
          padding: 3px;

          &:hover {
            border-radius: 4px;
            background: var(--scene-edit-left-bottom-menu-bgColor);

            .icon {
              color: var(--scene-edit-left-bottom-menu-icon-hover-color);
            }
          }
        }

        .icon {
          font-size: 18px;
          color: var(--scene-edit-left-bottom-menu-icon-color);
        }
      }
    }

    .common-empty-box {
      .empty-page {
        :deep(.el-empty__image) {
          img {
            width: 80%;
            height: 80%;
          }
        }
      }

      .text-box {
        color: #909399;
        font-size: 14px;
      }
    }
  }
}
</style>
